class LocalForageError extends Error {
  constructor(message) {
    super(message);
    this.name = "LocalForageError";
  }
}
class StorageQuotaError extends LocalForageError {
  constructor() {
    super("Storage quota exceeded");
    this.name = "StorageQuotaError";
  }
}
class SerializationError extends LocalForageError {
  constructor() {
    super("Failed to serialize/deserialize data");
    this.name = "SerializationError";
  }
}
export {
  LocalForageError,
  SerializationError,
  StorageQuotaError
};
